import { ENDPOINTS } from "@constants";
import AbstractService from "./AbstractService";
import NexusService from "./NexusService";
import FeatureFlagService from "./FeatureFlagService";

export default class JurisdictionLocationService extends AbstractService {
	static endpoint = ENDPOINTS.jurisdictionLocation;

	static jurisdictionLocationsApi = NexusService.jurisdictionLocationApprovalsApi;

	static jurisdictionLocationsFeature = "use_api_core_endpoints_jurisdiction_location_approvals";

	static getAll({ queryParams, getCancelToken }) {
		if(FeatureFlagService.isEnabled(this.jurisdictionLocationsFeature)) {
			const request = {};
			if (Object.hasOwn(queryParams, "pageNumber")) {
				request.pageNumber = queryParams.pageNumber;
			}
			if (Object.hasOwn(queryParams, "displayCount")) {
				request.displayCount = queryParams.displayCount;
			}
			if (Object.hasOwn(queryParams, "status")) {
				request.status = queryParams.status;
			}
			if (Object.hasOwn(queryParams, "search")) {
				request.search = queryParams.search;
			}
			return this.jurisdictionLocationsApi.getLocationApprovals(request)
				.then((response) => ({ data: response }));
		}

		return this.get({
			endpoint: this.endpoint,
			queryParams,
			getCancelToken,
		});
	}

	static getCounts() {
		if(FeatureFlagService.isEnabled(this.jurisdictionLocationsFeature)) {
			return this.jurisdictionLocationsApi.getLocationApprovalsCounts()
				.then((response) => ({ data: response }));
		}
		return this.get({
			endpoint: `${this.endpoint}/counts`,
		});
	}

	static updateMultiple({ queryParams, dataParams }) {
		if (FeatureFlagService.isEnabled(this.jurisdictionLocationsFeature)) {
			const request = {
				unassign: false,
				jurisdictionLocationApprovalPayload: {},
			};

			if (Object.hasOwn(queryParams, "unassign")) {
				request.unassign = queryParams.unassign;
			}

			const jurisdictionLocationApprovalPayload = dataParams.map(item => {
				const payload = {};
				if (Object.hasOwn(item, "Id")) {
						payload.Id = item.Id;
				}
				if (Object.hasOwn(item, "LocationGroupId")) {
					payload.LocationGroupId = item.LocationGroupId;
				}
				if (Object.hasOwn(item, "LocationId")) {
					payload.LocationId = item.LocationId;
				}
				if (Object.hasOwn(item, "JurisdictionId")) {
					payload.JurisdictionId = item.JurisdictionId;
				}
				if (Object.hasOwn(item, "GooglePlaceId")) {
					payload.GooglePlaceId = item.GooglePlaceId;
				}
				if (Object.hasOwn(item, "LocationName")) {
					payload.LocationName = item.LocationName;
				}
				if (Object.hasOwn(item, "Approved")) {
					payload.Approved = item.Approved;
				}
				return payload;
			});

			request.jurisdictionLocationApprovalPayload = jurisdictionLocationApprovalPayload;

			return this.jurisdictionLocationsApi.setJurisdictionLocationStatuses(request)
				.then((response) => ({ data: response }));
		}
		return this.post({
			endpoint: `${this.endpoint}/list`,
			data: dataParams,
			queryParams,
		});
	}

	static update({ queryParams, dataParams }) {
		if (FeatureFlagService.isEnabled(this.jurisdictionLocationsFeature)) {
			const request = {
				unassign: false,
				jurisdictionLocationApprovalPayload: {},
			};
			if (Object.hasOwn(queryParams, "unassign")) {
				request.unassign = queryParams.unassign;
			}
			if (Object.hasOwn(dataParams, "Id")) {
				request.jurisdictionLocationApprovalPayload.Id = dataParams.Id;
			}
			if (Object.hasOwn(dataParams, "LocationGroupId")) {
				request.jurisdictionLocationApprovalPayload.LocationGroupId = dataParams.LocationGroupId;
			}
			if (Object.hasOwn(dataParams, "LocationId")) {
				request.jurisdictionLocationApprovalPayload.LocationId = dataParams.LocationId;
			}
			if (Object.hasOwn(dataParams, "JurisdictionId")) {
				request.jurisdictionLocationApprovalPayload.JurisdictionId = dataParams.JurisdictionId;
			}
			if (Object.hasOwn(dataParams, "GooglePlaceId")) {
				request.jurisdictionLocationApprovalPayload.GooglePlaceId = dataParams.GooglePlaceId;
			}
			if (Object.hasOwn(dataParams, "LocationName")) {
				request.jurisdictionLocationApprovalPayload.LocationName = dataParams.LocationName;
			}
			if (Object.hasOwn(dataParams, "Approved")) {
				request.jurisdictionLocationApprovalPayload.Approved = dataParams.Approved;
			}
			return this.jurisdictionLocationsApi.setJurisdictionLocation(request)
				.then((response) => ({ data: response }));
		}
		return this.post({
			endpoint: `${this.endpoint}`,
			data: dataParams,
			queryParams,
		});
	}

	static create({ dataParams }) {
		if (FeatureFlagService.isEnabled(this.jurisdictionLocationsFeature)) {
			const request = {
				jurisdictionLocationCreatePayload: {},
			};
			if (Object.hasOwn(dataParams, "approved")) {
				request.jurisdictionLocationCreatePayload.Approved = dataParams.approved;
			}
			if (Object.hasOwn(dataParams, "city")) {
				request.jurisdictionLocationCreatePayload.City = dataParams.city;
			}
			if (Object.hasOwn(dataParams, "googlePlaceId")) {
				request.jurisdictionLocationCreatePayload.GooglePlaceId = dataParams.googlePlaceId;
			}
			if (Object.hasOwn(dataParams, "latitude")) {
				request.jurisdictionLocationCreatePayload.Latitude = dataParams.latitude;
			}
			if (Object.hasOwn(dataParams, "locationName")) {
				request.jurisdictionLocationCreatePayload.LocationName = dataParams.locationName;
			}
			if (Object.hasOwn(dataParams, "longitude")) {
				request.jurisdictionLocationCreatePayload.Longitude = dataParams.longitude;
			}
			if (Object.hasOwn(dataParams, "stateId")) {
				request.jurisdictionLocationCreatePayload.StateId = dataParams.stateId;
			}
			if (Object.hasOwn(dataParams, "streetAddress")) {
				request.jurisdictionLocationCreatePayload.StreetAddress = dataParams.streetAddress;
			}
			if (Object.hasOwn(dataParams, "zipcode")) {
				request.jurisdictionLocationCreatePayload.Zipcode = dataParams.zipcode;
			}
			return this.jurisdictionLocationsApi.addLocation(request)
				.then((response) => ({ data: response }));
		}
		return this.post({
			endpoint: `${this.endpoint}/location`,
			data: dataParams,
		});
	}
}
